module.exports = __webpack_public_path__ + "img/icons_17.744123af.svg";